"use client";
import React, { useState } from 'react';
import { Menu, X, Heart } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleWishlistClick = () => {
    navigate('/wishlist');
  };

  const handleCartClick = () => {
    navigate('/cart');
  };

  const navigationItems = [
    { name: 'PRE-WEDDING', filterValue: 'Pre Wedding' },
    { name: 'WOMEN', filterValue: 'Women' },
    { name: 'MEN', filterValue: 'Men' },
    { name: 'BRIDAL', filterValue: 'Bridal' },
    { name: 'KIDS', filterValue: 'Kids' },
    { name: 'OFFERS', filterValue: 'offers' }
  ];

  const categoryItems = [
    { name: "What's New", filterValue: "New Arrivals" },
    { name: "Sarees", filterValue: "Sarees" },
    { name: "Salwar Kameez", filterValue: "Salwar Kameez" },
    { name: "Lehengas", filterValue: "Lehengas" },
    { name: "Gowns", filterValue: "Gowns" },
    { name: "Men's Wear", filterValue: "Men's Wear" }
  ];

  const handleCategoryClick = (category, closeMobileMenu = false) => {
    // Close mobile menu if needed
    if (closeMobileMenu) {
      setIsMobileMenuOpen(false);
    }

    // Navigate to products page with category parameter
    const searchParams = new URLSearchParams();

    if (category.filterValue) {
      searchParams.set('category', category.filterValue);
    }

    const newUrl = `/products?${searchParams.toString()}`;

    // If already on products page, force reload by navigating away and back
    if (location.pathname === '/products') {
      
      setTimeout(() => {
        navigate(newUrl);
        // Scroll to top after navigation
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      }, 50);
    } else {
      navigate(newUrl);
      // Scroll to top after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handleLogoClick = () => {
    navigate('/');
    // Scroll to top when going home
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
     <header className="flex items-center justify-between w-full bg-white px-4 lg:px-12 py-2 relative">

  {/* Left: Logo + Brand */}
  <button
    className="flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
    onClick={handleLogoClick}
  >
    <img
      src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/602ab5c89aae71bf9fd0b889c5d6d9fdf098545c?placeholderIfAbsent=true"
      alt="Logo"
      className="w-12 h-12 rounded-full object-contain"
    />
    <div className="flex flex-col text-sm font-medium text-neutral-700">
      <span>ONE-STOP</span>
      <span>WEDDING DRESSES</span>
    </div>
  </button>

  {/* Center: Navigation */}
  <div className="absolute left-1/2 transform -translate-x-1/2">
    <nav className="hidden lg:flex gap-4 text-sm font-medium text-neutral-700">
      {navigationItems.map((item) => (
        <button
          key={item.name}
          className="px-5 py-2.5 rounded hover:bg-yellow-500 hover:text-white focus:bg-yellow-500 focus:text-white transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
          onClick={() => handleCategoryClick(item)}
        >
          {item.name}
        </button>
      ))}
    </nav>
  </div>

  {/* Right: Icons */}
  <div className="flex gap-4 items-center">
    <button onClick={handleWishlistClick} className="hover:opacity-80 transition-opacity">
      <Heart size={20} />
    </button>
    <button onClick={handleProfileClick} className="hover:opacity-80 transition-opacity">
      <img
        src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/d732d332372c6d1f76fc1ba9debfb399571b2dd3?placeholderIfAbsent=true"
        alt="Account"
        className="w-5 h-5 object-contain"
      />
    </button>
    <button onClick={handleCartClick} className="hover:opacity-80 transition-opacity">
      <img
        src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/d223a6352478999101d47face9d69751cc8ba53b?placeholderIfAbsent=true"
        alt="Cart"
        className="w-5 h-5 object-contain"
      />
    </button>
    {/* Mobile Menu Icon */}
<button
  className="lg:hidden hover:opacity-80 transition-opacity"
  onClick={toggleMobileMenu}
  aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
>
  {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
</button>

  </div>
</header>


      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-50" onClick={toggleMobileMenu}>
          <div className="bg-white w-80 h-full p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-semibold">Menu</h2>
              <button
                onClick={toggleMobileMenu}
                className="focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 rounded"
                aria-label="Close menu"
              >
                <X size={24} />
              </button>
            </div>

            {/* Navigation Items */}
            <div className="mb-6">
              <h3 className="text-sm font-medium text-gray-500 uppercase mb-3">Categories</h3>
              {navigationItems.map((item) => (
                <div key={item.name} className="mb-2">
                  <button
                    className="flex justify-start items-center px-4 py-3 rounded hover:bg-yellow-500 hover:text-white transition-colors cursor-pointer w-full text-left focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                    onClick={() => handleCategoryClick(item, true)}
                    aria-label={`Navigate to ${item.name} products`}
                  >
                    <span className="font-medium">{item.name}</span>
                  </button>
                </div>
              ))}
            </div>

            {/* Category Items */}
            {/* <div>
              <h3 className="text-sm font-medium text-gray-500 uppercase mb-3">Collections</h3>
              {categoryItems.map((item) => (
                <div key={item.name} className="mb-2">
                  <button
                    className="flex justify-start items-center px-4 py-3 rounded hover:bg-gray-100 transition-colors cursor-pointer w-full text-left focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    onClick={() => handleCategoryClick(item, true)}
                    aria-label={`Navigate to ${item.name} collection`}
                  >
                    <span className="text-sm">{item.name}</span>
                  </button>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
